import { PageContainer, PageIntroCard } from '@kmgestao/ui';

import { SuperadminShell } from '../../SuperadminShell.js';

import { PlatformSettingsForm } from './PlatformSettingsForm.js';

/**
 * Página Superadmin de "Plataforma" — edita os valores em
 * `public.platform_settings` (dados da contratada + footer
 * institucional) que aparecem nas propostas públicas.
 *
 * Protegida por `<RequireAuth>` + `<RequireSuperadmin>` no App.tsx,
 * igual às outras /superadmin/*. RLS no banco (`platform_settings_all_superadmin`)
 * é o guard final; esta camada só melhora UX.
 *
 * Escopo mínimo do PR A (2026-04-24): 8 campos fixos tipados em
 * `features/platform-settings-admin/schema.ts`. PR B expande pra
 * textos longos do ProposalPublicView (hero, sobre-nós, considerações).
 */
export function SuperadminPlatformSettingsPage() {
  return (
    <SuperadminShell>
      <PageContainer>
        <PageIntroCard
          eyebrow="Configurações · Plataforma"
          title="Dados da plataforma"
          description="Valores institucionais (razão social, CNPJ, responsável, rodapé) que aparecem em propostas comerciais. Alterar aqui reflete imediatamente em novas propostas — não precisa redeployar."
        />

        <PlatformSettingsForm />
      </PageContainer>
    </SuperadminShell>
  );
}
